import { Component } from 'react';

import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

import './styles/index.css';

/**
 * A component with accordion functionality
 */
class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded || false
    };
  }

  /**
   * @method UNSAFE_componentWillReceiveProps
   * @description update component state as per new props received
   * @returns updated state of component
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { expanded } = this.state;
    const { shouldUpdateFromProps } = this.props;
    if (nextProps.expanded !== expanded && shouldUpdateFromProps) {
      this.setState({ expanded: nextProps.expanded });
    }
    return null;
  }

  // Hnadles click for accordion open and close
  onClickHandler = () => {
    const { onClickHandler } = this.props;
    const { expanded } = this.state;
    if (expanded) {
      this.setState({ expanded: false });
    } else {
      onClickHandler();
      this.setState({ expanded: true });
    }
  };

  render() {
    const {
      headerTitle,
      highlight,
      closeIcon,
      openIcon,
      iconSize,
      maxHeight,
      animate,
      transitionTime,
      children,
      headingClass,
      clickHandler,
      customClick
    } = this.props;

    const { expanded } = this.state;
    const closeCustomIcon = closeIcon ? <CustomIcon type={closeIcon} className="icon-display" size={iconSize} /> : '';
    const openCustomIcon = openIcon ? <CustomIcon type={openIcon} className="icon-display" size={iconSize} /> : '';
    return (
      <>
        <div className={`accordion ${highlight && expanded ? 'accordion-highlight' : ''}`}>
          <div
            className="heading"
            onClick={customClick ? clickHandler : this.onClickHandler}
            onKeyUp={customClick ? clickHandler : this.onClickHandler}
            role="presentation"
          >
            <div className={`${headingClass || 'header-title'}`}>{headerTitle(expanded)}</div>
            <div className="icon-wrapper">{expanded ? closeCustomIcon : openCustomIcon}</div>
          </div>
          <div
            className="panel"
            style={{
              maxHeight: `${expanded ? maxHeight : '0px'}`,
              transition: `${animate ? transitionTime : '0'}`,
              display: `${expanded ? 'block' : 'none'}`
            }}
          >
            {children}
          </div>
        </div>
      </>
    );
  }
}

/**
 * @property propTypes
 * @description Defined property types for component
 * @type {{expanded: bool}} defines whether the accordion is open or closed
 * @type {{children: object}} component children
 * @type {{headerTitle: func}} function which returns jsx to be inserted as header
 * @type {{highlight: bool}} when true it adds a accordion-highlight class when
 * accordion is open
 * @type {{closeIcon: string}} icon to close accordion
 * @type {{openIcon: string}} icon to open accordion
 * @type {{maxHeight: string}} only required for open/close animation, when
 * animate prop is true it will be used to animate accordion panel's height
 * from 0px to the maxHeight value provided will be set 3000px which is a
 * significantly high value if the prop is not set
 * @type {{animate: bool}} when true open/close will have animation effect
 * @type {{transitionTime: string}} time for transition effect, mainly for
 * maxheight animation on open/close
 */
Accordion.propTypes = {
  expanded: PropTypes.bool,
  children: PropTypes.instanceOf(Object),
  headerTitle: PropTypes.func,
  highlight: PropTypes.bool,
  closeIcon: PropTypes.string,
  iconSize: PropTypes.string,
  openIcon: PropTypes.string,
  maxHeight: PropTypes.string,
  animate: PropTypes.bool,
  transitionTime: PropTypes.string,
  headingClass: PropTypes.string,
  clickHandler: PropTypes.func,
  customClick: PropTypes.bool,
  shouldUpdateFromProps: PropTypes.bool,
  onClickHandler: PropTypes.func
};

/**
 * @property defaultProps
 * @description Defined default prop values
 * @type {{expanded: string, children: string, headerTitle: func, highlight: bool, closeIcon: string, openIcon: string, maxHeight: string, animate: bool, transitionTime: string}}
 */
Accordion.defaultProps = {
  expanded: false,
  children: {},
  headerTitle: () => '',
  clickHandler: () => '',
  highlight: false,
  closeIcon: 'upArrow',
  openIcon: 'downArrow',
  maxHeight: '3000px',
  iconSize: '20',
  animate: false,
  transitionTime: '0',
  headingClass: '',
  customClick: false,
  shouldUpdateFromProps: true,
  onClickHandler: () => {}
};

export default Accordion;
